import type { SxProp } from 'src/types/mui';

export const hotCornerStyles =
  (isEnabled: boolean): SxProp =>
  theme => {
    const cornerColor = isEnabled ? theme.palette.primary.main : theme.palette.text.disabled;
    const cornerOpacity = isEnabled ? 0.72 : 0.32;

    return {
      position: 'absolute',
      bottom: 0,
      left: 0,
      zIndex: 1,
      width: 14,
      height: 14,
      p: 0,
      border: 'none',
      cursor: 'pointer',
      bgcolor: 'transparent',
      '&:hover, &:focus-visible': {
        outline: 'none',
        '&::before, &::after': {
          opacity: isEnabled ? 0.95 : 0.5,
        },
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        bottom: 4,
        left: 4,
        width: 7,
        height: 2,
        borderRadius: 1,
        bgcolor: cornerColor,
        opacity: cornerOpacity,
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shorter,
        }),
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 4,
        left: 4,
        width: 2,
        height: 7,
        borderRadius: 1,
        bgcolor: cornerColor,
        opacity: cornerOpacity,
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shorter,
        }),
      },
    };
  };

export const popoverContentStyles: SxProp = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  px: theme.spacing(1.5),
  py: theme.spacing(1),
  minWidth: 200,
});

export const popoverLabelStyles: SxProp = {
  fontSize: '0.75rem',
  lineHeight: 1.3,
};
